import { ThumbsDown, ThumbsUp } from '@components/icons'
import { thumbsUpClick } from '@lib/events/thumbsUpClick'
import { Content } from '@prismicio/client'
import { SliceComponentProps } from '@prismicio/react'
import cn from 'clsx'
import { useRouter } from 'next/router'
import { useState } from 'react'
declare global {
  interface Window {
    hj: any
  }
}
/**
 * Props for `HotjarSurveyBlock`.
 */
export type HotjarSurveyBlockProps =
  SliceComponentProps<Content.HotjarSurveyBlockSlice>

/**
 * Component for "HotjarSurveyBlock" Slices.
 */
const HotjarSurveyBlock = ({ slice }: HotjarSurveyBlockProps): JSX.Element => {
  const { asPath, query } = useRouter()
  const orderId = query.orderId
  const [clicked, setClicked] = useState(false)
  const {
    title,
    description,
    yes_option_translation,
    no_option_translation,
    paddingbottom,
    paddingtop,
    background_colour,
    post_purchase_feedback_block,
  } = slice?.primary || {}
  const sectionStyles = {
    paddingBottom: `${paddingbottom}px` || '0px',
    paddingTop: `${paddingtop}px` || '0px',
    backgroundColor: background_colour || '#F1F1F1',
  }
  const handleUsefulInformationFeedbackSurvey = () => {
    window.hj(
      'event',
      post_purchase_feedback_block
        ? 'Thumbs Up Post Purchase Triggered'
        : 'Useful Information Feedback Survey Triggered'
    )
    thumbsUpClick(asPath, orderId)
    setClicked(true)
  }
  const handleImprovementSuggestionsSurvey = () => {
    window.hj(
      'event',
      post_purchase_feedback_block
        ? 'Thumbs Down Post Purchase Triggered'
        : 'Improvement Suggestions Survey Triggered'
    )
    setClicked(true)
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      style={sectionStyles}
    >
      <div
        className={cn(
          'wrapper flex flex-col items-center justify-center gap-y-6 bg-white py-10',
          { '!max-w-216': post_purchase_feedback_block }
        )}
      >
        <div className="flex flex-col items-center justify-center gap-y-4">
          <div className="heading-mobile-4 md:heading-4 ">{title}</div>
          <div className="md:body-large body-1">
            {clicked ? 'Thank you for your feedback!' : description}
          </div>
        </div>
        <div className="flex gap-x-6">
          <button
            disabled={clicked}
            onClick={handleUsefulInformationFeedbackSurvey}
            className={cn('flex flex-col items-center justify-center gap-y-1', {
              'cursor-not-allowed': clicked,
            })}
          >
            <ThumbsUp />
            <div className="body-2">{yes_option_translation}</div>
          </button>
          <button
            disabled={clicked}
            onClick={handleImprovementSuggestionsSurvey}
            className={cn('flex flex-col items-center justify-center gap-y-1', {
              'cursor-not-allowed': clicked,
            })}
          >
            <ThumbsDown />
            <div className="body-2">{no_option_translation}</div>
          </button>
        </div>
      </div>
    </section>
  )
}

export default HotjarSurveyBlock
